export default __webpack_public_path__ + "static/media/enable-oo-cta.9ae7db84.png";